"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkDateBetween = void 0;
const checkDateBetween = (currentDate, minDate, maxDate) => {
    const diffStartTime = currentDate.valueOf() - minDate.valueOf() >= 0;
    const diffEndTime = maxDate.valueOf() - currentDate.valueOf() >= 0;
    return diffStartTime && diffEndTime;
};
exports.checkDateBetween = checkDateBetween;
